import { render, staticRenderFns } from "./coldAnalysis.vue?vue&type=template&id=05315fbb&"
import script from "./coldAnalysis.vue?vue&type=script&lang=js&"
export * from "./coldAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./coldAnalysis.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports